/**
 * Conversione tra data ISO `YYYY-MM-DD` e settimana ISO `YYYY-Www`,
 * + enumerazione dei 7 giorni di una settimana ISO.
 *
 * Tutte le funzioni rispettano la regola ISO-8601: la W1 è la settimana che
 * contiene il 4 gennaio (equivalentemente, il primo giovedì dell'anno).
 * Anchor su Jan 4 evita l'off-by-one quando il 1° gennaio cade Tue/Wed/Thu
 * (es. 2026 Jan 1 = giovedì → W1 inizia il 2025-12-29).
 */
export function weekFromIsoDate(dateStr) {
  try {
    // 'Z' esplicita: senza, la data è interpretata nel fuso locale del browser
    // ma i calcoli sotto usano i metodi UTC → per ogni utente non-UTC (es.
    // Europe/Rome) la mezzanotte locale è il giorno UTC precedente e la
    // settimana slitta di uno. In container UTC (test Emergent) non si vede.
    const d = new Date(dateStr + 'T00:00:00Z');
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const wn = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    return `${d.getUTCFullYear()}-W${String(wn).padStart(2, '0')}`;
  } catch {
    return null;
  }
}

/**
 * Ritorna i 7 giorni ISO della settimana `YYYY-Www` come array di stringhe
 * `YYYY-MM-DD`, da Lunedì a Domenica.
 *
 * @example daysOfIsoWeek('2026-W27') → ['2026-06-29','2026-06-30',…,'2026-07-05']
 */
export function daysOfIsoWeek(isoWeek) {
  const [y, w] = isoWeek.split('-W').map(Number);
  // ISO-8601: W1 contiene il 4 gennaio. Trovo il lunedì della settimana di Jan 4.
  const jan4 = new Date(Date.UTC(y, 0, 4));
  const jan4Day = jan4.getUTCDay() || 7;
  const week1Mon = new Date(jan4);
  week1Mon.setUTCDate(jan4.getUTCDate() - (jan4Day - 1));
  // +7*(W-1) giorni per arrivare al lunedì della settimana richiesta
  const monday = new Date(week1Mon);
  monday.setUTCDate(week1Mon.getUTCDate() + 7 * (w - 1));
  return Array.from({ length: 7 }).map((_, i) => {
    const d = new Date(monday);
    d.setUTCDate(monday.getUTCDate() + i);
    return d.toISOString().slice(0, 10);
  });
}
